import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { FunctionComponent } from "react";
import { ListItemButton, Tooltip } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FoundationProgramMenu } from "../common/foundationProgramMenu/foundationProgramMenu";
import { OlympiadExamMenu } from "../common/OlympiadExamMenu/olympiadExamMenu";
import { VideoLessionFilesMenu } from "../common/videoLessionFilesMenu/VideoLessionFilesMenu";
import { isSelected } from "../common/utilities/utils";

const EXPANDED_WIDTH = 280;
const COLLAPSED_WIDTH = 64;

export const InstitutionNavMenu: FunctionComponent = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = React.useState(true);
  const expandMenu = () => setMenuOpen(true);

  return (
    <>
      <CssBaseline />
      <Drawer
        variant="permanent"
        className="menu-container"
        sx={{
          flexShrink: 0,
          width: menuOpen ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
          transition: 'width 0.25s ease',
          "& .MuiDrawer-paper": {
            width: menuOpen ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
            boxSizing: "border-box",
            paddingTop: 10,
            overflowX: 'hidden',
            transition: 'width 0.25s ease',
          },
        }}
      >
        <Box sx={{ overflow: "auto", fontSize: '0.875rem' }}>
          <List>
            {/* Collapse / expand toggle */}
            <ListItemButton
              onClick={() => setMenuOpen(!menuOpen)}
              sx={{ justifyContent: menuOpen ? 'flex-end' : 'center', minHeight: 44, px: 1.5 }}
            >
              <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center' }}>
                {menuOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </ListItemIcon>
            </ListItemButton>
            <Divider />

            <Tooltip title={menuOpen ? '' : 'Home'} placement="right">
              <ListItemButton
                component="a"
                href="#/school/Home"
                selected={isSelected(location.pathname, "/school/home")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <HomeIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Home'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            <Tooltip title={menuOpen ? '' : 'Shared Files'} placement="right">
              <ListItemButton
                component="a"
                href="#/school/sharedfiles"
                selected={isSelected(location.pathname, "/school/sharedfiles")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <FolderSharedIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Shared Files'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            <FoundationProgramMenu menuCollapsed={!menuOpen} onExpandRequest={expandMenu} />
            <OlympiadExamMenu menuCollapsed={!menuOpen} onExpandRequest={expandMenu} />
            <VideoLessionFilesMenu menuCollapsed={!menuOpen} onExpandRequest={expandMenu} />

            <Tooltip title={menuOpen ? '' : 'Abhyasa Bharathi Magazine'} placement="right">
              <ListItemButton
                component="a"
                href="#/magzine/abhyasabharathi"
                selected={isSelected(location.pathname, "/magzine/abhyasabharathi")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <LibraryBooksIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Abhyasa Bharathi Magazine'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            <Tooltip title={menuOpen ? '' : 'Certifications'} placement="right">
              <ListItemButton
                component="a"
                href="#/School/Certifications"
                selected={isSelected(location.pathname, "/School/Certifications")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <WorkspacePremiumIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Certifications'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            {/* <Tooltip title={menuOpen ? '' : 'Help'} placement="right">
              <ListItemButton
                component="a"
                href="#/school/Help"
                selected={isSelected(location.pathname, "/school/help")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <HelpOutlineIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Help'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip> */}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
